import constants from 'constants';

const {
  ADD_PARTNERS,
  ADD_ADMIN_PARTNERS,
  CLEAN_PARTNERS,
  SET_TEMP_PARTNER,
  SET_PARTNERS
} = constants;

const partners = (partners = {
  list: {
    values: [],
    isLoaded: false
  },
  admin: {
    list: {
      values: [],
      page: 0,
      pages: 0,
      total_pages: 0,
      query: {
        title: '',
        order: {
          created_at: 'desc'
        }
      }
    },
    tmp: {}
  }
}, {
  type,
  payload
}) => {
  switch (type) {
    case ADD_PARTNERS:
      return {
        ...partners,
        ...{
          list: {
            values: payload.values,
            isLoaded: true
          }
        }
      }
    case ADD_ADMIN_PARTNERS:
      return {
        ...partners,
        ...{
          admin: {
            ...partners.admin,
            list: {
              values: payload.values,
              page: payload.page,
              total_pages: payload.total_pages,
              count: payload.count
            }
          }
        }
      }
    case SET_PARTNERS:
      return {
        ...partners,
        ...{
          list: {
            ...partners.list,
            values: payload
          }
        }
      }
    case CLEAN_PARTNERS:
      return {
        ...partners,
        admin: {
          ...partners.admin,
          list: {
            values: [],
            page: 0,
            pages: 0,
            total_pages: 0,
            query: {
              title: '',
              order: {
                created_at: 'desc'
              }
            }
          },
          tmp: {}
        }
      }
    case SET_TEMP_PARTNER:
      return {
        ...partners,
        admin: {
          ...partners.admin,
          tmp: payload.partner
        }
      }
    default: return partners
  }
}

export { partners };



// WEBPACK FOOTER //
// ./src/reducers/partners.js